var _defs, _path, _use, _use2, _use3, _use4, _use5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-cn",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#ff0",
    d: "M1-.3-.7.8 0-1 .6.8-1-.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h512v512H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 30,
    height: 20,
    transform: "matrix(76.8 0 0 76.8 128 128)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 30,
    height: 20,
    transform: "rotate(-121 142.6 -47) scale(25.5827)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 30,
    height: 20,
    transform: "rotate(-98.1 198 -82) scale(25.6)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 30,
    height: 20,
    transform: "rotate(-74 272.4 -114) scale(25.6137)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 30,
    height: 20,
    transform: "matrix(16 -19.968 19.968 16 256 230.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.814b7a346be4f0b26b4a1547b9eee4bd.svg";
export { ForwardRef as ReactComponent };